module.exports = __webpack_public_path__ + "img/loginbg.b99f727b.png";